import React, { useEffect, useState } from 'react';
import './CampaignCardComponent.styles.scss';
import { useHistory, useParams, Link } from 'react-router-dom';

import { Button, message, Popconfirm, Tooltip } from 'antd';
import { dispatch, useGlobalState } from '../../../store/state';
// import { SyncCampiagnData } from '../../../utils/SyncCampiagnData';
import moment from 'moment';
import CurrencyIcon from '../../Common/CurrencyIcon';
import { AcceptCampaign } from '../../../apis/Influencer/Campaigns/AcceptCampaign';
// import { CampaignDelete } from '../../../apis/Brand/Campaigns/CampaignDelete';

const CampaignCardComponent = ({ status, timeLeft, createdOn, title, campaignid, socialIcons, taskCount, deleteCampaign, earningData, submissions, rowData }) => {
  const history = useHistory();
  // const params = useParams();
  const [user] = useGlobalState('user');
  const [totalPosts, setTotalPosts] = useState(0);
  // const [creativeStats,setcreativeStats] = useState({
  //     rejected: rowData.submissions.filter(obj=>{
  //         if(obj.status ==='rejected'){
  //             return obj.count
  //         }
  //     }) || 0,
  //     accepted: rowData.submissions.filter(obj=>{
  //         if(obj.status ==='accepted'){
  //             return obj.count
  //         }
  //     }) || 0,
  //     review: rowData.submissions.filter(obj=>{
  //         if(obj.status ==='review'){
  //             return obj.count
  //         }
  //     }) || 0
  // })
  useEffect(()=>{
    const _v = submissions.reduce(function (sum, current) {
      return sum + current.count;
    }, 0);
    setTotalPosts(_v || 0);
  }, [submissions]);
  // const [company] = useGlobalState('company')
  // const [create_camp_general] = useGlobalState('create_camp_general')
  // const [create_camp_draft] = useGlobalState('create_camp_draft')
  // const [campDefSet] = useGlobalState('campDefSet')

  // @note: this is to accept campaign on the go
  const acceptAndRedirect = () =>{
    AcceptCampaign(user.accessToken, { campaignid: campaignid }).then(({ status, response })=>{
      console.log('join campaign', response);
      if (status === 200) {
        message.success('Campaign Accepted Successfully');
        history.push(`/influencer/campaigns/${campaignid}`);
      } else {
        message.error('There is some issue to accept Campaign');
      }
    });
  };


  return (
    <div className="col-xl-4 col-md-6 p-2">
      <div className="campaign_card h-100">
        <div className="d-flex flex-column justify-content-between h-100">

          <div>
            <div className="campaign_card_top">
              <div className="campaign_card_top--status"
                status={status}>{status}</div>
              <div className="campaign_card_top_stamps">
                {/* <div className="campaign_card_top_stamps--left">Starts {timeLeft}</div> */}
                <div className="campaign_card_top_stamps--left"><div>Campaign Id</div> {campaignid}</div>
                {/* <div className="campaign_card_top_stamps--creation"><div>Created on</div> {moment(createdOn).format('Do MMM YYYY')}</div> */}
              </div>

              {/* <div className="campaign_card_top_stamps">
                                <div className="campaign_card_top_stamps--left">{timeLeft}</div>
                                <div className="campaign_card_top_stamps--creation">Created on {moment(createdOn).format('Do MMM YYYY')}</div>
                            </div> */}
            </div>
            <h2 className="campaign_card--title mt-3">{title}</h2>
            <h5 className="campaign_card--earn">
              <i>Avg. earnings per posts</i>
              {CurrencyIcon()}<span>{earningData.min}</span> to <span>{earningData.max}</span>
            </h5>
            {/* <h5 className="campaign_card--id">{campaignid}</h5> */}
          </div>

          <div>
            <div className="campaign_card_bottom">
              <div className="campaign_card_bottom_obj pt-2">
                {/* <h6>Platform</h6> */}
                <div className="campaign_card_bottom_obj--social">
                  <i>Platform</i>
                  {socialIcons}
                  {/* <span>
                                        <FaFacebookF/>
                                    </span>
                                    <span>
                                        <FaInstagram/>
                                    </span> */}
                </div>
                {/* <div className="campaign_card_bottom_obj_earns">
                                    <p>Avg.ernings per posts</p>
                                    <div>
                                        {CurrencyIcon()}<span>{earningData.min}</span> to <span>{earningData.max}</span>
                                    </div>
                                </div> */}
                {/* <p className="pt-1">{taskCount}</p> */}
                <p className="pt-1">Total {totalPosts} Posts</p>
              </div>
              <div className="campaign_card_bottom_actions">
                {status === 'assigned' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                      {/* <Link to={`/influencer/campaigns/${campaignid}`}> */}
                      {/* <Button className="common_button outlined" onClick={acceptAndRedirect}>Accept</Button> */}
                      {/* </Link> */}
                    </>
                  ):
                  null
                }
                {status === 'accepted' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                      <Link to={`/influencer/campaigns/${campaignid}/creatives`}>
                        <Button className="common_button outlined">Submit</Button>
                      </Link>
                    </>
                  ):
                  null
                }
                {status === 'review' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                      {/* <Tooltip
                                                color="red"
                                                title="Important: There is some creatives Rejected by Admin,"
                                            > */}
                      <Link to={`/influencer/campaigns/${campaignid}/creatives/review`}>
                        <Button className="common_button outlined">Re-Submit</Button>
                      </Link>
                      {/* </Tooltip> */}
                    </>
                  ):
                  null
                }
                {status === 'approved' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                    </>
                  ):
                  null
                }
                {status === 'active' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                      <Link to={`/influencer/campaigns/${campaignid}/creatives/review`}>
                        <Button className="common_button outlined">Share Links</Button>
                      </Link>
                    </>
                  ):
                  null
                }
                {status === 'closed' || status === 'completed' ?
                  (
                    <>
                      <Link to={`/influencer/campaigns/${campaignid}/creatives/review`}>
                        <Button className="common_button outlined">View Details</Button>
                      </Link>
                      {/* <Link to={`/influencer/campaigns/${campaignid}/creatives/review`}> */}
                      {/* <Button className="common_button" onClick={RaiseInvoice}>Raise Invoice</Button> */}
                      {/* </Link> */}
                    </>
                  ):
                  null
                }
                {status === 'self_reject' ?
                  (
                    <Button className="common_button outlined"
                      disabled>View Details</Button>
                  ):
                  null
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CampaignCardComponent;
